// Module
var code = "<div layout=\"column\" layout-align=\"end start\"> <div ng-repeat=\"item in $ctrl.items\" layout=\"row\" layout-align=\"start center\"> <bringoz-package-item id=\"key\" name-only=\"true\"></bringoz-package-item> <span class=\"br-body-2\">X {{item.count}} = {{item.sizeCharge | bringozPrice : currency}}</span> </div> </div> ";
// Exports
export default code;